import webDevImage from '../images/web-dev.png';
import dataAnalysisImage from '../images/data-analysis.png';
import dataScienceImage from '../images/data-science.png';

const professionHeroTitles = [
  {
    id: 'web-dev',
    title: 'What web development requests can we help with?',
    subtitle:
      'Practicum by Yandex students are ready to build your website from your design or if necessary, we can ask our colleagues from the design team to create a unique design for your company and a website based on this design.',
    image: webDevImage,
    alt: 'calendar',
  },
  {
    id: 'data-analysis',
    title: 'What data analysis requests can we help with?',
    subtitle:
      'Practicum by Yandex students are ready to undertake analytics of the data provided by the company or if necessary, are ready to conduct market research to obtain the necessary data for analysis.',
    image: dataAnalysisImage,
    alt: 'crystal ball',
  },
  {
    id: 'data-science',
    title: 'What data science requests can we help with?',
    subtitle:
      'Practicum by Yandex students are ready to undertake analytics of the data provided by the company or if necessary, are ready to conduct market research to obtain the necessary data for analysis.',
    image: dataScienceImage,
    alt: 'rubiks cube',
  },
];

export default professionHeroTitles;
